/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const config = {};

config.cookie_first = 'a6946219-3a42-4676-8c2a-d933e05ce061';
config.google_tag_manager = 'GTM-K2Q2F58';
config.google_tag_manager_auth = 'ZFcyBxHCnqAELKmmToTAHA';
config.google_tag_manager_preview = 'env-11';
config.google_tag_manager_cookies_win = 'x';
config.adobe_analytics = false;
config.hotjar = null;
export default config;
